import React from "react";

export const AndroidIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      d="M25.5942 22.8906C24.8365 22.8906 24.2201 22.2737 24.2201 21.516C24.2201 20.7583 24.8365 20.142 25.5942 20.142C26.352 20.142 26.9683 20.7582 26.9683 21.516C26.9683 22.2739 26.352 22.8906 25.5942 22.8906ZM10.4058 22.8906C9.64814 22.8906 9.0318 22.2737 9.0318 21.516C9.0318 20.7583 9.64801 20.142 10.4058 20.142C11.1635 20.142 11.7799 20.7582 11.7799 21.516C11.7799 22.2739 11.1637 22.8906 10.4058 22.8906ZM26.087 14.6132L28.8333 9.85673C28.9089 9.72546 28.9294 9.56957 28.8902 9.42325C28.8509 9.27694 28.7553 9.15215 28.6242 9.07627C28.4929 9.00071 28.337 8.98029 28.1907 9.0195C28.0444 9.0587 27.9196 9.15433 27.8437 9.28541L25.0631 14.102C22.9365 13.1316 20.5484 12.591 18 12.591C15.4516 12.591 13.0635 13.1316 10.937 14.102L8.15626 9.28541C8.08036 9.15433 7.95558 9.0587 7.80927 9.0195C7.66296 8.98029 7.50708 9.00071 7.37581 9.07627C7.24463 9.15208 7.14891 9.27687 7.1097 9.42321C7.07048 9.56956 7.09097 9.72549 7.16667 9.85673L9.91298 14.6132C5.19717 17.178 1.97185 21.9522 1.5 27.5926H34.5C34.0278 21.9523 30.8025 17.178 26.087 14.613"
      fill="black"
    />
  </svg>
);
